import projectCopy from "./ProjectCopy/ProjectCopy.js";
import Login from "./Login/Login";
import listCopy from "./ListCopy/ListCopy.js";
import externalApiCopy from "./ExternalAPiCopy/ExternalApiCopy.js";
import activeFilters from "./ActiveFilters/ActiveFilters.js";
import Language from "./Language/Language.js";
import {combineReducers} from 'redux';


const rootReducer = combineReducers({
    projectCopy,
    Login,
    listCopy,
    externalApiCopy,
    activeFilters,
    Language,
});


export default rootReducer;